import React from 'react';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PropTypes from 'prop-types';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {openFile} from 'Shared/utilities/fetchHelpers';
import {MarketingDTO} from 'Documents/api';
import {Button, useMediaQuery} from '@material-ui/core';
import {createSnackbar} from 'Core/ducks/snackbar';
import {useDispatch} from 'react-redux';
import {Conflict, NotFound, ServerError, Unauthorized} from 'Core/models/Async';
import {theme} from 'Core/components/WithTheme';

type MarketingDocumentProps = {
  marketing: MarketingDTO;
  selectedAgency: AgencyFilters;
};

const MarketingDocuments = (props: MarketingDocumentProps) => {
  const {marketing} = props;
  const marketingUrl = `/api/documents/v1/marketingForms/all/${marketing.fId}`;
  const fileExtension = `pdf`;
  const successResponse = `Sucessfully Downloaded!`;

  const dispatch = useDispatch();
  const getMarketingDoc = () => {
    dispatch(createSnackbar('Request initiated!'));
    const response = openFile(marketingUrl, '', successResponse);
    response.then(value => {
      const pdfResponse: any = value;
      if (typeof pdfResponse === 'string') {
        dispatch(createSnackbar(successResponse));
      } else if (pdfResponse instanceof NotFound) {
        dispatch(createSnackbar(pdfResponse.message));
      } else if (pdfResponse instanceof Unauthorized) {
        dispatch(createSnackbar(pdfResponse.message));
      } else if (pdfResponse instanceof Conflict) {
        dispatch(createSnackbar(pdfResponse.message));
      } else if (pdfResponse instanceof ServerError) {
        dispatch(createSnackbar(pdfResponse.message));
      } else {
        dispatch(createSnackbar('Unable to download form!'));
      }
    });
  };

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Button
        id={`marketing-form-view-details-btn-${marketing.fId}`}
        className="primary-action-button"
        color="primary"
        onClick={() => getMarketingDoc()}
      >
        {isMobile ? (
          <DescriptionOutlinedIcon fontSize="small" color="error" />
        ) : (
          <DescriptionOutlinedIcon color="error" />
        )}
      </Button>
    </>
  );
};

MarketingDocuments.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.object),
  date: PropTypes.string,
  uniquePolicyNumber: PropTypes.string,
};
MarketingDocuments.defaultProps = {
  documents: [],
  date: null,
  uniquePolicyNumber: null,
};
export default MarketingDocuments;
